import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Load runtime config first (if available)
import { getConfig } from './utils/config';
// Setup axios interceptors before anything else
import './utils/axiosSetup';
import App from './App';

// Preload config on startup (non-blocking)
getConfig().catch(() => {
  // Silently fail - getConfigSync will use fallbacks
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Check if root already has content (might indicate double mounting)
if (rootElement.children.length > 0) {
  rootElement.innerHTML = '';
}

const root = ReactDOM.createRoot(rootElement);

// Add error boundary
try {
  root.render(
    <App />
  );
} catch (error) {
  console.error('[Index] Error rendering app:', error);
  rootElement.innerHTML = '<div style="padding: 20px; color: red;"><h1>Error Rendering App</h1><pre>' + JSON.stringify(error, null, 2) + '</pre></div>';
}
